<template>
  <v-container>
    <p class="display-1">Fakturační údaje</p>
    <v-form
      ref="form"
      v-model="formValid"
    >
      <v-row cols="12" class="justify-center">
        <v-col
          cols="6">
          <v-row id="company">
            <v-col cols="12">
              <v-text-field
                label="Jméno a příjmení / Název společnosti"
                v-model="form.name"
                outlined
                :rules="[rules.required]"
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            label="IČO"
            v-model="form.ico"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="DIČ"
            v-model="form.dic"
            outlined
            required
          >
          </v-text-field>
          <v-text-field
            label="Email"
            v-model="form.email"
            outlined
            :rules="[rules.required, rules.email]"
            required
          >
          </v-text-field>
          <v-text-field
            label="Telefon"
            v-model="form.phone"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="Adresa"
            v-model="form.street"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="Číslo popisné"
            v-model="form.streetNumber"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="Město"
            v-model="form.city"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-text-field
            label="PSČ"
            v-model="form.zip"
            outlined
            :rules="[rules.required]"
            required
          >
          </v-text-field>
          <v-btn
            color="primary"
            class="float-right"
            @click="save"
            :disabled="!formValid || wait"
          >
            Uložit
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import rules from '../../../mixins/rules'
export default {
  mixins: [rules],
  name: 'BillingInformation',
  data () {
    return {
      wait: false,
      formValid: true,
      form: {
        name: '',
        ico: '',
        dic: '',
        email: '',
        phone: '',
        street: '',
        streetNumber: '',
        city: '',
        zip: ''
      }
    }
  },
  methods: {
    save () {
      this.wait = true
      this.$http({
        method: 'post',
        url: '/admin/billing',
        data: this.keysToSnakeCase({
          ...this.form
        })
      })
        .then(response => {
          this.getInfo()
          scrollTo(0, 0)
          this.wait = false
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 422) {
            alert('Neplatné údaje')
          } else {
            alert('Chyba')
          }
        })
    },
    getInfo () {
      this.$refs.form.reset()
      this.$http.get('/admin/billing')
        .then(response => {
          const data = this.keysToCamelCase(response.data)
          this.form = {
            ...data
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getInfo()
  }
}
</script>

<style scoped>

</style>
